"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoiceSharingResponseModelCategory = void 0;
exports.VoiceSharingResponseModelCategory = {
    Generated: "generated",
    Cloned: "cloned",
    Premade: "premade",
    Professional: "professional",
    Famous: "famous",
    HighQuality: "high_quality",
};
